export const OktaClientId = '0oaop0jixngcdBAzt696'
export const ENV = 'qa2' as string
export const OVERSIGHT_ENV_NAME = 'oversight-staging-qa'
export const GCS_ENV_NAME = 'staging-qa2'
export const SUBDOMAIN_SUFFIX = 'gcs-staging-qa'
